/**
 * Entry ID Redirects
 * 
 * This file maintains a mapping of old entry IDs to new entry IDs.
 * When an entry's ID changes, add a mapping here to ensure old links continue to work.
 * 
 * The redirect system will automatically redirect users from old URLs to new ones.
 * 
 * Format:
 * - Key: Old entry ID (the deprecated ID)
 * - Value: New entry ID (the current ID)
 * 
 * Example:
 * When "pf.priority.domains" was renamed to "pf.items.kinds", we add:
 * 'pf.priority.domains': 'pf.items.kinds'
 */

export const entryRedirects: Record<string, string> = {
  // Entry ID changes
  'pf.priority.domains': 'pf.items.kinds',
  
  // Add future redirects here as entries are renamed
  // 'old.entry.id': 'new.entry.id',
};

/**
 * Get the current entry ID for a given (possibly old) entry ID.
 * Returns the current ID if a redirect exists, otherwise returns the original ID.
 * 
 * @param entryId - The entry ID to resolve (may be old or current)
 * @returns The current entry ID
 */
export function resolveEntryId(entryId: string): string {
  return entryRedirects[entryId] || entryId;
}

/**
 * Check if an entry ID is a redirect (has been changed).
 * 
 * @param entryId - The entry ID to check
 * @returns True if this is a redirect, false otherwise
 */
export function isRedirect(entryId: string): boolean {
  return entryId in entryRedirects;
}

/**
 * Get all redirect mappings for documentation purposes.
 * 
 * @returns Record of old ID -> new ID mappings
 */
export function getAllRedirects(): Record<string, string> {
  return { ...entryRedirects };
}



